// extracted by mini-css-extract-plugin
export default {"container":"PageTitle_container__XSbQ4","reverse":"PageTitle_reverse__6VFY6"};